import { render } from "./present.vue?vue&type=template&id=69acf0f8&scoped=true"
import script from "./present.vue?vue&type=script&lang=js"
export * from "./present.vue?vue&type=script&lang=js"

import "./present.vue?vue&type=style&index=0&id=69acf0f8&lang=scss&scoped=true"
import "./present.vue?vue&type=style&index=1&id=69acf0f8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69acf0f8"]])

export default __exports__